import Cookies from "js-cookie"

import Hook from "../utils/hook"
import { getNavigatorGeoLocationCoordinates } from "../utils/geo"

export default Hook(`LocationTracker`, {
  refs: [`acceptButton`],
  targets: [`acceptButton`, `denyButton`],
  values: { cookieName: String, error: String },
  actions: [
    {
      name: `accept`,
      target: `acceptButton`,
      type: `click`,
    },
    {
      name: `deny`,
      target: `denyButton`,
      type: `click`,
    },
  ],

  acceptAction() {
    if (this.acceptButtonRef) this.acceptButtonRef.setLoading(true)

    getNavigatorGeoLocationCoordinates()
      .then(({ lat, lng }) => {
        this.set(`${lat},${lng}`)
        window.location.reload()
      })
      .catch(() => {
        this.putFlash({
          type: `error`,
          text: this.errorValue,
        })
        if (this.acceptButtonRef) this.acceptButtonRef.setLoading(false)
      })
  },

  denyAction() {
    this.set(`deny`)
  },

  set(value) {
    Cookies.set(this.cookieNameValue, value, {
      expires: value == `deny` ? 14 : 365,
    })

    Cookies.set(`${this.cookieNameValue}:time`, Date.now(), {
      expires: 365,
    })

    this.classAdd(`hidden`)
  },
})
